import * as Yup from "yup";
import { validationResult } from "./patterns";
import { runFlatFormSchema } from "./yupFormUtils";

// Bad-bot action cards exposed in the BM Configuration UI.
const BAD_BOT_UI_ACTIONS = new Set([0, 3, 4]); // LOG, CHALLENGE, BLOCK
const CHALLENGE_KIND_VALUES = new Set(["invisible", "managed", "adaptive", "interactive"]);

function validateBadBotAction(value) {
  const n = typeof value === "number" ? value : parseInt(value, 10);
  if (!Number.isFinite(n) || !BAD_BOT_UI_ACTIONS.has(n)) {
    return validationResult(false, "Select a bad bot action");
  }
  return validationResult(true);
}

function validateChallengeKind(value) {
  if (value == null || value === "") {
    return validationResult(false, "Select a challenge kind");
  }
  if (!CHALLENGE_KIND_VALUES.has(String(value))) {
    return validationResult(false, "Select a challenge kind");
  }
  return validationResult(true);
}

function enabledSchema() {
  return Yup.object({
    bad_bot_action: Yup.mixed().test("bad_bot_action", function (value) {
      const result = validateBadBotAction(value);
      return result.valid || this.createError({ message: result.message });
    }),
    bm_challenge_kind: Yup.mixed().test("bm_challenge_kind", function (value) {
      const result = validateChallengeKind(value);
      return result.valid || this.createError({ message: result.message });
    }),
  });
}

export function validateBmConfigForm({ enabled, bad_bot_action, bm_challenge_kind } = {}) {
  if (!enabled) {
    return { valid: true, errors: {} };
  }
  return runFlatFormSchema(enabledSchema(), { bad_bot_action, bm_challenge_kind });
}
